import { collection, query, orderBy, limit, getDocs, doc, getDoc } from "firebase/firestore";
import { firestore } from "../firebase";
import { TrackData } from "../types/Types";

export const UpvotedTracksService = {
    async getUpvotedTracks(): Promise<TrackData[]> {
        try {
            const upvotesRef = collection(firestore, "trackUpvotes");
            const q = query(upvotesRef, orderBy("dateUpvoted", "desc"), limit(50));
            const upvoteSnapshot = await getDocs(q);

            const uniqueTrackIds = new Set<string>();
            upvoteSnapshot.docs.forEach((d) => {
                const trackId = d.data().trackId;
                if (trackId) uniqueTrackIds.add(trackId);
            });

            const finalTrackIds = Array.from(uniqueTrackIds).slice(0, 20);

            const trackPromises = finalTrackIds.map(async (id) => {
                const trackDoc = await getDoc(doc(firestore, "trackLinks", id));
                if (trackDoc.exists()) {
                    return { id: trackDoc.id, ...trackDoc.data() } as TrackData;
                }
                return null;
            });

            const results = await Promise.all(trackPromises);

            return results.filter((track): track is TrackData => track !== null);
        } catch (error) {
            console.error("Error fetching upvoted tracks:", error);
            return [];
        }
    }
};